import {
  AdapterInfo,
  AnalyticsInfo,
  FETCH_ANALYTICS_CONFIG,
  RESET_ADAPTER_DETAILS,
  RESET_ANALYTICS_DETAILS,
} from "./AdapterConfigTypes";
import { FETCH_ADAPTER_CONFIG } from "./AdapterConfigTypes";

export interface AdapterConfigState {
  AdapterInfo: AdapterInfo;
  AnalyticsInfo: AnalyticsInfo;
  isAnalayticsEnabled: boolean | null;
}

const initialState: AdapterConfigState = {
  AdapterInfo: {
    adapterId: "",
    capabilities: [],
    operations: [],
    props: {
      PRODUCT_DETAILS_MAX_WORKERS: undefined,
      PRODUCT_DETAILS_PAGESIZE: undefined,
    },
  },
  AnalyticsInfo: {
    adapterId: "",
    capabilities: [],
    operations: [],
  },
  isAnalayticsEnabled: null,
};

export const AdapterConfigReducer = (
  state: AdapterConfigState = initialState,
  action,
): AdapterConfigState => {
  const data = action.payload;
  switch (action.type) {
    case FETCH_ADAPTER_CONFIG.SUCCESS:
      return {
        ...state,
        AdapterInfo: data,
      };
    case RESET_ADAPTER_DETAILS:
      return {
        ...state,
        AdapterInfo: {
          adapterId: "",
          capabilities: [],
          operations: [],
          props: {
            PRODUCT_DETAILS_MAX_WORKERS: undefined,
            PRODUCT_DETAILS_PAGESIZE: undefined,
          },
        },
      };
    case FETCH_ANALYTICS_CONFIG.SUCCESS:
      return {
        ...state,
        AnalyticsInfo: data,
        isAnalayticsEnabled: true,
      };
    case FETCH_ANALYTICS_CONFIG.FAILURE:
      return {
        ...state,
        isAnalayticsEnabled: false,
      };
    case RESET_ANALYTICS_DETAILS:
      return {
        ...state,
        AnalyticsInfo: {
          adapterId: "",
          capabilities: [],
          operations: [],
        },
        isAnalayticsEnabled: null,
      };
    default:
      return state;
  }
};
